import React from 'react';

import styles from './styles.module.scss';

const RectangleRedDash = (props: { width?: string }) => (
  <img
    src={
      // eslint-disable-next-line max-len
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAV4AAABYCAYAAAC9BZ+zAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAALXSURBVHic7dwhcltXFMfhc6/UjFmyg7KUucxL6BaCDLODehXpDgqzi8JCs5qlrLgkYR7HurekwKNKHbu2/q+Wv4+e0ZsDzvzAG0ntz3fvZj2B1trlnPP8KZ61pNb72Rzj49J7bGu9n88xLpfe47Faax/nnGdL73GX2z0st/tP/SkeAsD9CS9AmPAChAkvQJjwAoSt9w161YdR9ft9H9Q2m8+zP/+OfzPGp5uq90vvse3vvZ69ttl8mL2/WXqPu9zuYb3U2+1Vb0fVxa7Z3vDO3q/qAV8BGUdwuFVVN1VfqurXpffYdgyHW1U1er9aeodtbvewXurtzt6va4yds+O4OIBnRHgBwoQXIEx4AcKEFyBMeAHChBcgTHgBwoQXIEx4AcLWrbU/dg3a7e31Mfx+HWAJ7fb2ularnX1dzzl/2DUQXYD/bvR+VXv6qq4AYcILECa8AGHCCxAmvABhwgsQJrwAYcILECa8AGHCCxAmvABhwgsQJrwAYcILECa8AGHCCxAmvABhwgsQJrwAYcILECa8AGHCCxAmvABhwgsQJrwAYcILECa8AGHCCxAmvABhwgsQJrwAYcILECa8AGHCCxAmvABhwgsQJrwAYcILECa8AGHCCxAmvABhwgsQJrwAYcILECa8AGHCCxAmvABhwgsQJrwAYevW2i+7Bm2z+XH0fpVeCOAY9DFO52r1067Zes757c5PrdcnNcZBFwM4VnO9Pplj7OyrVw0AYcILECa8AGHCCxAmvABhwgsQJrwAYcILECa8AGHCCxC23jdoY5zOqpP7PqiP8fkY/tvhVdXrm6rvl95j26uq326qviy9x2P1MU5H72+W3uMut3tYL/V22xhv557Z3vCOqouHLDVXq8ua8/whn/k/+tr7dzXGz0vvse1r7+c1xuXSezzWXK0uas6zpfe4y+0e1ku93X/7pxuvGgDChBcgTHgBwoQXIEx4AcL+An+kv1ucCBdhAAAAAElFTkSuQmCC'
    }
    width={props.width || '28'}
    height="7"
    alt="red-rec"
    aria-hidden
    className={styles.image}
  />
);

export default RectangleRedDash;
